import { render, staticRenderFns } from "./VideoAddPage.vue?vue&type=template&id=04dc59a3&scoped=true&"
import script from "./VideoAddPage.vue?vue&type=script&lang=js&"
export * from "./VideoAddPage.vue?vue&type=script&lang=js&"
import style0 from "./VideoAddPage.vue?vue&type=style&index=0&id=04dc59a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc59a3",
  null
  
)

export default component.exports